import React from 'react';
import './Partners.css';
import { Helmet } from 'react-helmet';

// Import all partner logos
import dubhackslogo from './partnerlogos/dubhackslogo.png';
import ecolearnerslogo from './partnerlogos/ecolearnerslogo.png';
import healtheplanetlogo from './partnerlogos/healtheplanetlogo.png';
import netimpactlogo from './partnerlogos/netimpactlogo.png';
import rethinklogo from './partnerlogos/rethinklogo.png';
import washpirglogo from './partnerlogos/washpirglogo.png';

const Partners = () => {
  // Partner data with logos and website links
  const partners = [
    { name: 'DubHacks', logo: dubhackslogo, website: 'https://dubhacks.co' },
    { name: 'EcoLearners', logo: ecolearnerslogo, website: 'https://ecolearners.org' },
    { name: 'Heal the Planet', logo: healtheplanetlogo, website: 'https://healtheplanet.com' },
    { name: 'Net Impact', logo: netimpactlogo, website: 'https://netimpact.org' },
    { name: 'Rethink', logo: rethinklogo, website: 'https://www.rethinkuw.org/' },
    { name: 'WashPIRG', logo: washpirglogo, website: 'https://washpirg.org' },
  ];

  return (
    <div className="partners-container">

<Helmet>
  <title>Our Partners | Verdure</title>
  <meta name="description" content="Meet the sustainability organizations, student groups, and community partners that help us vet and feature incredible indie brands." />
  <meta property="og:title" content="Our Partners | Verdure" />
  <meta property="og:description" content="We work with vetted organizations and students to ensure every brand we feature is ethical and sustainable." />
</Helmet>

      <h2 className="partners-title">Our Partners</h2>
      <div className="partners-grid">
        {partners.map((partner, index) => (
          <div className="partner-card" key={index}>
            <a 
              href={partner.website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="partner-link"
              aria-label={`Visit ${partner.name} website`}
            >
              <img 
                src={partner.logo} 
                alt={`${partner.name} logo`} 
                className="partner-logo"
              />
              <p className="partner-name">{partner.name}</p>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;